import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {UuidGenerator} from "../../utils/UuidGenerator";

declare var ko: any;

export class pollQuestion_template extends vnTemplate{


    protected uuidGeneratore: UuidGenerator;


    protected getTemplateHtml(): string{
        return `
            <div class="w-form-body poll-add-question-form">
                <strong class="form-sub-title" data-bind="text: headerTitle, css: {'is-hidden': hideHeaderTitle }"></strong>
                <div class="poll-add-question-form-body">
                <div class="w-form-body w-add-question-body">
                    <div class="form-body">
                        <div class="form-group">
                        <label for="title" class="form-label">Question</label>
                        <textarea id="title" rows="2" class="input-text poll-question-title-input" data-bind="value: question, valueUpdate: 'keyup'" type="text"></textarea>
                        <small class="from-error" data-bind="text: pollNameError, css: { 'is-hidden': pollNameError() == '' }"></small>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                        <label for="type" class="form-label">Question Type</label>
                        <select name="" id="" data-bind="value: questionType">
                            <option value="single-select">Single Select</option>
                            <option value="multi-select">Multi Select</option>
                        </select>
                        </div>
                        <div class="form-group">
                        <!-- ko if: pollSections().length > 0 -->
                        <label for="type" class="form-label">Section</label>
                        <select name="pollSectionSelection" id="" data-bind="value: pollSectionId">
                            <option value="0">Select</option>
                            <!-- ko foreach: pollSections -->
                                <option data-bind="text: name, value: id"></option>
                            <!-- /ko -->
                        </select>
                        <!-- /ko -->
                        </div>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-group w-add-question-choices">
                        <label class="form-label">+ Add an option</label>
                        <div class="row"> 
                            <input type="text" class="input-text" style="flex:1;margin-left: 0" autocapitalize="off" data-bind="value: choiceLabel, valueUpdate: 'keyup'">
                            <button id="add_choice" class="btn border icon only-icon i-add" data-bind="event: {click: onClickAddChoice}, disable: choiceLabel() == ''" type="button"></button>
                        </div>
                        <small class="from-error" style="color: var(--ck-color-base-error)" data-bind="text: choicesError, css: { 'is-hidden': choicesError() == '' }"></small>
                    </div>
                    <div id="spec_section" class="form-group choices">
                        <div class="poll-choices-toolbar" data-bind="visible: choices().length > 0">
                            <button type="button" class="btn btn--small poll-choices-expand-all" data-bind="click: onClickToggleAllCommercial"><span data-bind="text: commercialToggleLabel"></span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5"/></svg></button>
                        </div>
                        <div id="spec_section_list" data-bind="foreach: choices, childrenComplete: handleDragAndDrop($element, choices, '.poll-question-option')">
                            <div class="form-group poll-question-option">
                                <div class="row poll-question-option-row">
                                    <span class="poll-choice-label" type="text" data-bind="text: choiceLabel"></span>
                                    <div class="row poll-question-option-actions" style="align-items: center">
                                        <button type="button" class="btn only-icon poll-choice-commercial-toggle" title="Commercial Signal" data-bind="event: {click: $parent.onClickToggleCommercial }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5"/></svg></button>
                                        <button type="button" class="btn border icon only-icon i-close poll-choice-delete" data-bind="event: {click: $parent.onClickDeleteChoice }"></button>
                                    </div>
                                </div>
                                <div class="row poll-commercial-signal" style="gap:0.5rem;margin-top:0.5rem" data-bind="visible: commercialOpen">
                                    <select style="flex:1" data-bind="value: commercialSignal">
                                        <option value="" disabled>Select Commercial Signal</option>
                                        <!-- ko foreach: $parent.signalTypes -->
                                            <option data-bind="value: label, text: label"></option>
                                        <!-- /ko -->
                                    </select>
                                    <input type="text" style="flex:1;margin-left:0" class="input-text" placeholder="Entity" autocapitalize="off" data-bind="value: commercialEntity, valueUpdate: 'keyup'">
                                    <input type="text" style="flex:1;margin-left:0" class="input-text" placeholder="Value" autocapitalize="off" data-bind="value: commercialValue, valueUpdate: 'keyup'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                
                <div class="form-footer w-add-question-footer">
                        <button class="btn" type="button" data-bind="event: {click: onClickCancelQuestion }">Cancel</button>
                    <!-- ko if: operation() == 'add' -->
                        <button class="btn highlight" type="button" data-bind="event: {click: onClickAddQuestion }">Add</button>
                    <!-- /ko -->
                    
                    <!-- ko if: operation() == 'edit' -->
                        <button class="btn highlight" type="button" data-bind="event: {click: onClickUpdateQuestion }">Update</button>
                    <!-- /ko -->
                </div>
            </div>
        `;
    }


    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    protected initPartial(): void {
        this.uuidGeneratore = new UuidGenerator();
    }

    protected getTemplateName(): string{
        return "pollQuestion-template";
    }
    protected getMainElementClasses(): Array<string>{
        return ['w-form-body'];
    }
    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            operation: ko.observable('add'),
            headerTitle: ko.observable("+ Add Question"),
            hideHeaderTitle: ko.observable(true),
            choiceLabel: ko.observable(""),
            choiceText: ko.observable(""),
            id: ko.observable(""),
            question: ko.observable(""),
            questionType: ko.observable(""),
            pollSections: ko.observableArray([]),
            signalTypes: ko.observableArray([]),
            choices: ko.observableArray([]),
            pollSectionId: ko.observable(null),
            pollNameError: ko.observable(''),
            choicesError: ko.observable(''),
            onClickCancel:  (data, event) => { self.onClickCancel(data) },
            onClickSave:  (data, event) => { self.onClickSave() },
            onClickAddChoice:  (value, data, event) => { self.onClickAddChoice(); },
            onClickDeleteChoice:  (data, event) => { self.onClickDeleteChoice(data); },
            onClickToggleCommercial:  (data, event) => { self.onClickToggleCommercial(data); },
            onClickToggleAllCommercial: () => { self.onClickToggleAllCommercial(); },
            commercialToggleLabel: ko.pureComputed(function() {
                let choices = self.getTemplateViewModel().choices();
                if (!choices.length) {
                    return 'Show commercial signals';
                }
                let allExpanded = choices.every(function(choice) {
                    return ko.unwrap(choice.commercialOpen);
                });
                return allExpanded ? 'Hide commercial signals' : 'Show commercial signals';
            }),
            onClickClearQuestion: (data, event) => {self.onClickClearQuestion(data)},
            onClickAddQuestion: (data, event) => {self.onClickAddQuestion(data)},
            onClickCancelQuestion: (data, event) => {self.onClickCancelQuestion(data)},
            onClickUpdateQuestion: (data, event) => {self.onClickUpdateQuestion(data)},
            handleDragAndDrop: (element, currentObservableArray, childrenSelector) => {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
        };
    }


    public onClickSave(){
        this.caller.savePoll();
    }

    public onClickCancel(data){
        this.caller.cancel(data.id());
    }


    protected onClickAddChoice() {

        let choices = this.getTemplateViewModel().choices();

        let id = 1;
        for(let choice of choices){
            if (choice.id >= id){
                id = choice.id + 1;
            }
        }

        let choice = {
            uuid: this.uuidGeneratore.uuid(),
            id: id,
            votes: 0,
            choiceLabel: this.getChoiceLabel(),
            choiceText: this.getChoiceLabel(),
            commercialSignal: "",
            commercialEntity: "",
            commercialValue: "",
        };

        this.addChoice(choice);
        this.setChoiceLabel('');
        this.setChoiceText('');
    }

    protected onClickDeleteChoice(data) {

        let index = this.getTemplateViewModel().choices().findIndex(element => element == data);
        if (index > -1) {
            this.getTemplateViewModel().choices.splice(index, 1);
        }
    }

    public onClickClearQuestion(data) {
        this.reset();
    }

    public reset() {
        this.setId(null);
        this.setChoices([]);
        this.setQuestion('');
        this.setQuestionType('single-select');
        this.setPollSectionId(0);
        this.setPollNameError('');
        this.setOptionsError('');
        this.asAdd();
    }

    public setPollNameError(error) {
        this.getTemplateViewModel().pollNameError(error);
    }

    public setOptionsError(error) {
        this.getTemplateViewModel().choicesError(error);
    }

    public onClickAddQuestion(data) {

        let questionTxt = this.getQuestion();
        if (questionTxt === null || questionTxt === undefined || questionTxt.trim() === '') {
            this.setPollNameError("Question is required.");
            return;
        }
        this.setPollNameError("");

        let optionsList = this.getChoices();
        if (optionsList.length === 0) {
            this.setOptionsError("Options are required.");
            return;
        }
        this.setOptionsError("");

        if (!this.validateCommercialFields()) {
            return;
        }

        let uuid = this.uuidGeneratore.uuid();
        let question = this.buildQuestionObject(uuid);
        this.caller.addQuestionToList(question);
    }

    public onClickUpdateQuestion(data) {

        let questionTxt = this.getQuestion();
        if (questionTxt === null || questionTxt === undefined || questionTxt.trim() === '') {
            this.setPollNameError("Question is required.");
            return;
        }
        this.setPollNameError("");

        let optionsList = this.getChoices();
        if (optionsList.length === 0) {
            this.setOptionsError("Options are required.");
            return;

        }
        this.setOptionsError("");

        if (!this.validateCommercialFields()) {
            return;
        }

        let uuid = this.getId();
        let question = this.buildQuestionObject(uuid);
        this.caller.updateEditedQuestionInList(question);
    }

    public onClickCancelQuestion(data) {
        this.caller.cancelEditedQuestionInList(data);
    }


    private buildQuestionObject(uuid) {

        let pollSectionId = this.getPollSectionId();
        if (pollSectionId === null) {
            pollSectionId = 0;
        }
        let pollSectionName = 'Unassigned';
        if (pollSectionId !== 0 && pollSectionId !== "0") {
            let selectedSection = this.getSelectedSection();
            pollSectionName = selectedSection.name;
        }
        return {
            "id": uuid,
            "type": this.getQuestionType(),
            "choices": this.getCleanChoices(),
            "section": pollSectionName,
            "sectionId": pollSectionId,
            "votes": 0,
            "position": 1,
            "question": this.getQuestion()
        };
    }

    // Unwrap observables and drop the UI-only commercialOpen flag before persisting.
    private getCleanChoices() {
        return this.getChoices().map((choice) => {
            let clean: any = {};
            for (let key in choice) {
                if (!choice.hasOwnProperty(key) || key === 'commercialOpen') {
                    continue;
                }
                clean[key] = ko.unwrap(choice[key]);
            }
            return clean;
        });
    }

    // Each answer must have either none or all three commercial fields.
    private validateCommercialFields(): boolean {
        let choices = this.getChoices();
        for (let choice of choices) {
            let filled = 0;
            if ((ko.unwrap(choice.commercialSignal) || '').toString().trim() !== '') { filled++; }
            if ((ko.unwrap(choice.commercialEntity) || '').toString().trim() !== '') { filled++; }
            if ((ko.unwrap(choice.commercialValue) || '').toString().trim() !== '') { filled++; }
            if (filled !== 0 && filled !== 3) {
                this.setOptionsError("Each answer must have either none or all three commercial fields (Signal, Entity, Value).");
                return false;
            }
        }
        return true;
    }

    public getSelectedSection() {
        let selectedSectionId = this.getPollSectionId();
        let sections = this.getPollSections();
        let match = sections.filter((s) => s.id === selectedSectionId);

        let selectedSection = null;
        if (match.length > 0) {
            selectedSection = match[0]
        }

        return selectedSection;
    }
    public getId(){
        return this.getTemplateViewModel().id();
    }
    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public setHideHeaderTitle(hideHeaderTitle) {
        this.getTemplateViewModel().hideHeaderTitle(hideHeaderTitle);
    }
    public getHideHeaderTitle() {
        return this.getTemplateViewModel().hideHeaderTitle();
    }
    private setOperation(operation){
        this.getTemplateViewModel().operation(operation);
    }

    private getOperation() {
        return this.getTemplateViewModel().operation();
    }
    public isEdit() {
        return this.getOperation() === 'edit';
    }

    public asEdit() {
        this.setOperation('edit');
        this.setheaderTitle('Update Question');
    }

    public isAdd() {
        return this.getOperation() === 'add';
    }

    public asAdd() {
        this.setOperation('add');
        this.setheaderTitle('Add Question');
    }

    private setheaderTitle(headerTitle) {
        this.getTemplateViewModel().headerTitle(headerTitle);
    }

    private getheaderTitle() {
        return this.getTemplateViewModel().headerTitle();
    }
    public setPollSectionId(pollSectionId) {
        this.getTemplateViewModel().pollSectionId(pollSectionId);
    }

    public getPollSectionId() {
        return this.getTemplateViewModel().pollSectionId();
    }

    public getPollSections() {
        return this.getTemplateViewModel().pollSections();
    }

    public setPollSections(pollSections) {
        this.getTemplateViewModel().pollSections(pollSections);
    }

    public getSignalTypes() {
        return this.getTemplateViewModel().signalTypes();
    }

    public setSignalTypes(signalTypes) {
        this.getTemplateViewModel().signalTypes(signalTypes || []);
    }

    public setQuestion(question){
        this.getTemplateViewModel().question(question);
    }

    public getQuestion() {
        return this.getTemplateViewModel().question();
    }

    public setQuestionType(type){
        this.getTemplateViewModel().questionType(type);
    }

    public getQuestionType() {
        return this.getTemplateViewModel().questionType();
    }

    public setChoiceLabel(choiceLabel) {
        this.getTemplateViewModel().choiceLabel(choiceLabel);
    }

    public getChoiceLabel() {
        return this.getTemplateViewModel().choiceLabel();
    }

    public setChoiceText(choiceText) {
        this.getTemplateViewModel().choiceText(choiceText);
    }

    public getChoiceText() {
        return this.getTemplateViewModel().choiceText();
    }


    public setChoices(choices){
        this.getTemplateViewModel().choices(this.normalizeChoices(choices));
    }

    private normalizeChoices(choices) {
        return (choices || []).map((choice) => {
            if (choice.commercialSignal === undefined || choice.commercialSignal === null) {
                choice.commercialSignal = "";
            }
            if (choice.commercialEntity === undefined || choice.commercialEntity === null) {
                choice.commercialEntity = "";
            }
            if (choice.commercialValue === undefined || choice.commercialValue === null) {
                choice.commercialValue = "";
            }
            if (!ko.isObservable(choice.commercialOpen)) {
                choice.commercialOpen = ko.observable(false);
            }
            return choice;
        });
    }

    protected onClickToggleCommercial(choice) {
        if (ko.isObservable(choice.commercialOpen)) {
            choice.commercialOpen(!choice.commercialOpen());
        }
    }

    protected onClickToggleAllCommercial() {
        let choices = this.getChoices();
        if (!choices.length) {
            return;
        }

        let allExpanded = choices.every(function(choice) {
            return ko.unwrap(choice.commercialOpen);
        });
        let targetState = !allExpanded;

        choices.forEach(function(choice) {
            if (ko.isObservable(choice.commercialOpen)) {
                choice.commercialOpen(targetState);
            }
        });
    }

    public getChoices(){
        return this.getTemplateViewModel().choices();
    }

    public addChoice(choice) {
        let choices = this.getChoices();
        choices.push(choice);
        this.setChoices(choices);
    }

    public setPollQuestion(question) {
        this.setId(question.id);
        this.setQuestion(question.question);
        this.setQuestionType(question.type);
        this.setChoices(question.choices);
        this.setPollSectionId(question.sectionId);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollQuestion_template.ts